import CoreSettingsTab from "./CoreSettingsTab"
import GoodToKnowTab from "./GoodToKnowTab"
import SyncOrdersTab from "./SyncOrdersTab"
import TrackingPageTab from "./TrackingPageTab"

export const MIGRATE_SETUP_GUIDE_TAB_CONTENTS = [
  SyncOrdersTab,
  TrackingPageTab,
  CoreSettingsTab,
  GoodToKnowTab,
] as const

export {
  CoreSettingsTab,
  GoodToKnowTab,
  SyncOrdersTab,
  TrackingPageTab,
}
